import React, {useCallback, useMemo, useState} from "react";
import {Checkbox, ConfigProvider, Modal} from "antd";
import {Images} from "../../images/Images";
import {PageTitleHeader} from "../../components";
import "./notify-about-order-update-modal.css";
import {editOrderNotificationsOption, editOrderNotificationsReceivers} from "./consts.jsx";

const {companyWizardSuccess} = Images;

const defaultWhoToSendUpdateEmailOptions = [
    editOrderNotificationsReceivers.provider,
    editOrderNotificationsReceivers.company
];

export const NotifyAboutAdminOrderUpdateModal = ({
    visible,
    onClose,
    onSave,
    defaultWhoToSendUpdateEmail = defaultWhoToSendUpdateEmailOptions
}) => {
    const [whoToSendUpdateEmail, setWhoToSendUpdateEmail] = useState(
        defaultWhoToSendUpdateEmail ?? defaultWhoToSendUpdateEmailOptions
    );

    const onFinish = useCallback(() => {
        onSave(whoToSendUpdateEmail);
        setWhoToSendUpdateEmail(defaultWhoToSendUpdateEmail);
    }, [onSave, setWhoToSendUpdateEmail, whoToSendUpdateEmail]);

    const notificationsOptions = useMemo(
        () => editOrderNotificationsOption.filter(o => defaultWhoToSendUpdateEmail.includes(o.value)),
        [defaultWhoToSendUpdateEmail]
    );

    return (
        <Modal
            centered={true}
            width={500}
            height={562}
            className="wb-modal-radius wb-modal-borderless notify-about-order-update-modal"
            style={{borderRadius: "5px"}}
            destroyOnClose={true}
            open={visible}
            onCancel={() => onClose()}
            footer={null}
            title={null}
            closable={true}>
            <ConfigProvider direction="rtl">
                <img src={companyWizardSuccess} alt="modal image" />
                <PageTitleHeader className="notify-about-order-update-modal-header" showBack={false}>
                    האם לשלוח מייל עידכון?
                </PageTitleHeader>
                <div className="simple-modal-text-container"></div>
                <div className="notify-about-order-update-modal-checkbox-break-line" />
                <Checkbox.Group
                    onChange={setWhoToSendUpdateEmail}
                    className="notify-about-order-update-modal-checkboxes-container"
                    options={notificationsOptions}
                    defaultValue={whoToSendUpdateEmail}
                />
                <div onClick={onFinish} className="notify-about-order-update-modal-send">
                    שליחה
                </div>
            </ConfigProvider>
        </Modal>
    );
};
